import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "confirm-your-refinance-details-modal"
}
const _hoisted_2 = { class: "loans-to-refinance-section-wrapper" }
const _hoisted_3 = { class: "two-column-grid" }
const _hoisted_4 = {
  key: 0,
  class: "text-center error"
}

import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import DialogueModal from "@/components/modals/DialogueModal.vue";
import LoansToRefinanceTable from "@/components/refi-loans-table/LoansToRefinanceTable.vue";
import Modal from "@/components/shared/Modal.vue";
import NextButton from "@/components/shared/NextButton.vue";
import RefiLoanConfigurationDetails from "@/components/refi-loan-configuration/RefiLoanConfigurationDetails.vue";
import CircleLoader from "@/components/shared/CircleLoader.vue";
import useEsignConfirmation from "@/composables/useEsignConfirmation";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmYourRefinanceDetailsModal',
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {

const store = useStore();

const emit = __emit;

const { confirmChangesREFI, esignErrorMessage, esignResponseError, gettingData, loading } =
  useEsignConfirmation();

const showDialogueModal = ref<boolean>(false);

const loans = computed(() => store?.getters["applicationInfoModule/RefiLoans"]);

function openDialogueModal() {
  showDialogueModal.value = true;
}

function handleDialogueModal() {
  store.dispatch("applicationInfoModule/discardChanges");
  store.dispatch("applicationInfoModule/closeModal", "ConfirmYourRefinanceDetails");
}

function closeModal() {
  showDialogueModal.value = true;
}

async function getRefiLoanDetailsModal() {
  await store.dispatch(
    "applicationInfoModule/getRefiLoanModalData",
    store.state.appData?.application?.id,
  );

  gettingData.value = false;
}

onMounted(() => {
  gettingData.value = true;
  getRefiLoanDetailsModal();
});

__expose({
  closeModal,
  getRefiLoanDetailsModal,
  handleDialogueModal,
  loans,
  openDialogueModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    closeBtn: true,
    onClose: closeModal
  }, {
    default: _withCtx(() => [
      (_unref(gettingData))
        ? (_openBlock(), _createBlock(CircleLoader, {
            key: 0,
            inline: true
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Confirm Your Refinance Details", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("p", null, "Before you sign, please review your loans, payoffs, and terms.", -1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(LoansToRefinanceTable, {
                showPayoffDetails: true,
                showActionsColumn: false,
                showAddLoanButton: false,
                id: "Parent_ConfirmYourRefinanceDetailsModal"
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(RefiLoanConfigurationDetails),
              _createElementVNode("div", null, [
                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "italic" }, " By clicking Ready to Sign, you acknowledge that you have reviewed and agree with all payoff details listed above. ", -1)),
                _createVNode(NextButton, {
                  disabled: _unref(loading),
                  loading: _unref(loading),
                  text: "Ready to Sign",
                  onClick: _withModifiers(_unref(confirmChangesREFI), ["prevent"])
                }, null, 8, ["disabled", "loading", "onClick"])
              ])
            ]),
            (_unref(esignResponseError))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(esignErrorMessage)) + " Please try again later. If the issue persists, please contact our support team. ", 1))
              : _createCommentVNode("", true),
            (showDialogueModal.value === true)
              ? (_openBlock(), _createBlock(DialogueModal, {
                  key: 1,
                  onCancel: _cache[0] || (_cache[0] = ($event: any) => (showDialogueModal.value = false)),
                  onConfirm: handleDialogueModal,
                  title: `Quit editing?`,
                  msg: `Any changes you\'ve made so far will not be saved`,
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No'
                }))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }))
}
}

})